import { ForecastTimelineFilterProperty, RequiredForecastTimelineFilterProperty } from '@/coreDomainsModule/entities/filter';
import { CustomerForecastTimelineRequiredFilterItem } from '@/coreInfrastructureModule/axios/generated/customerForecastManage';

/**
 * 関連取引IDを取得するユースケースのアダプタ
 */
export class GetBaseBusinessIdAdapter {
  /**
   * 関連取引ID取得のリクエストに適した形式に変換する
   * @param customerForecastFilterProperty - フィルタ
   */
  public static adaptForRequest(
    customerForecastFilterProperty: RequiredForecastTimelineFilterProperty
  ): CustomerForecastTimelineRequiredFilterItem {
    return {
      // baseBusinessUserId: customerForecastFilterProperty.staffName,
      warehouseNumber: customerForecastFilterProperty.warehouseCode,
      warehouse: customerForecastFilterProperty.warehouse,
      supplierNumber: customerForecastFilterProperty.supplierCode,
      supplierName: customerForecastFilterProperty.supplierName,
      businessNumber: customerForecastFilterProperty.businessCode,
      businessName: customerForecastFilterProperty.businessName,
      package: customerForecastFilterProperty.packageAmount,
      customerNumber: customerForecastFilterProperty.customerCode,
      customerName: customerForecastFilterProperty.customerName,
      salesDestinationNumber: customerForecastFilterProperty.salesDestinationCode,
      salesDestinationName: customerForecastFilterProperty.salesDestinationName,
    };
  }
}
